import { Classes } from '@blueprintjs/core'
import * as React from 'react'
import EmptyPlaceHolder from '../../../../../../components/EmptyPlaceholder'
import { UprightStyle } from '../../../../../../types'

interface Props {
  name: string
  value: string | number
}

const styles: UprightStyle = {
  box: {
    padding: '0px 16px 4px 0'
  },
  key: { marginBottom: 5 },
  value: { marginBottom: 0, fontWeight: 'bold' }
}

export const ListingProperty: React.FC<Props> = props => {
  const value = props.value === 0 ? `${props.value}` : props.value
  return (
    <div style={styles.box}>
      <p style={styles.key} className={Classes.TEXT_SMALL}>
        {props.name}
      </p>
      <p style={styles.value}>
        <EmptyPlaceHolder>{value}</EmptyPlaceHolder>
      </p>
    </div>
  )
}
